import React from 'react'
import styled from 'styled-components'
import { Flex, Text, TextVariant } from '@mprolab/uikit'
import { Link } from 'react-router-dom'
import MainWrapper from 'layouts/MainWrapper'
import { StyledBiennale } from 'components'
import { RELEASE_NOTES } from './notes'

/**
 * Every version of Terminal, in full.
 *
 * **Versions, never dates** (operator, 2026-09-07). A date invites the reader
 * to work out how long the gaps were, which is a fact about us rather than
 * about the product; the version is the number a holder compares against the
 * one in their own Settings.
 *
 * Each entry is anchored on its version, so the table on the Terminal page can
 * link straight to the row somebody clicked.
 */

const Column = styled(Flex)`
  width: 100%;
  flex-direction: column;
  margin: 152px 0 120px;
`

const StyledTitle = styled(StyledBiennale)`
  font-size: 32px;
`

const Back = styled(Link)`
  color: ${({ theme }) => theme.colors.cyan};
  text-decoration: none;
  font-size: 14px;
  margin-bottom: 24px;
`

const Lead = styled(Text)`
  max-width: 720px;
  margin-top: 12px;
  color: ${({ theme }) => theme.colors.gray3};
`

const Entry = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 22px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray8};

  &:last-child {
    border-bottom: none;
  }
`

const Head = styled(Flex)`
  align-items: baseline;
  gap: 14px;
  flex-wrap: wrap;
`

const Version = styled(Text)`
  font-family: monospace;
  color: ${({ theme }) => theme.colors.cyan};
`

const Detail = styled(Text)`
  max-width: 760px;
  color: ${({ theme }) => theme.colors.gray3};
`

const TerminalReleases: React.FC = () => (
  <MainWrapper>
    <Column>
      <Back to="/terminal">← Terminal</Back>
      <StyledTitle variant={TextVariant.H3}>Release notes</StyledTitle>
      <Lead variant={TextVariant.BODY_DEFAULT}>
        Every version, newest first. Terminal shows the one it runs under Settings, and updates
        itself when a newer one is published.
      </Lead>

      <Flex flexDirection="column" width="100%" mt="24px">
        {RELEASE_NOTES.map((note) => (
          /*
           * The id is the anchor the Terminal page's table links to. It carries
           * a `v` prefix because an id may not begin with a digit and a
           * selector for one does not work without escaping it.
           */
          <Entry key={note.version} id={`v${note.version}`}>
            <Head>
              <Version variant={TextVariant.BODY_DEFAULT_BOLD}>{note.version}</Version>
              <Text variant={TextVariant.BODY_DEFAULT_BOLD}>{note.headline}</Text>
            </Head>
            <Detail variant={TextVariant.BODY_SMALL}>{note.detail}</Detail>
          </Entry>
        ))}
      </Flex>
    </Column>
  </MainWrapper>
)

export default TerminalReleases
